module.exports = __webpack_public_path__ + "static/media/ppa-desktop-screens.387f96ac.png";